module.exports = __webpack_public_path__ + "img/22.10.pH.9da00c2b.png";